import { atom } from 'recoil';

export interface PodcastStatus {
  has_podcast: boolean;
  is_outdated: boolean;
  podcast_url: string | null;
  created_at: string | null;
  last_message_at: string | null;
  current_last_message_at: string | null;
  size_bytes: number | null;
  file_extension: string;
  podcast_name: string | null;
}

export interface PodcastState {
  isLoading: boolean;
  isGenerating: boolean;
  status: PodcastStatus | null;
  error: string | null;
}

export const podcastState = atom<PodcastState>({
  key: 'podcastState',
  default: {
    isLoading: false,
    isGenerating: false,
    status: null,
    error: null,
  },
});
